/* eslint-disable */
import React, { Component } from 'react';

import Classes from './NextSongControllableItem.css';

import ReactTooltip from 'react-tooltip';

class NextSongControllableItem extends Component {
  render() {
    let trendClassName = Classes.CardPositive;
    let trendArrow = 'up-arrow.svg';

    if (this.props.trend === 'negative') {
      trendClassName = Classes.CardNegative;
      trendArrow = 'down-arrow.svg';
    }

    let userPicture = '';
    if (!this.props.pictureUser) {
      userPicture = '.';
    } else {
      userPicture = this.props.pictureUser;
    }

    return (
      <div className={[trendClassName, 'row', Classes.NoSpace, 'd-flex', 'align-self-center', 'align-items-center', 'justify-content-center'].join(' ')}>
        {/** Song Picture */}
        <div className="col-md-1">
          <img
            src={`${this.props.songImage}?auto=compress&cs=tinysrgb`}
            className={[Classes.SongImage, 'img-responsive'].join(' ')}
            alt={this.props.songName}
            title={this.props.songName}
          />
        </div>
        {/** Song Title & Description */}
        <div className="col-md-3">
          <p className={Classes.SongTitle}>
            {this.props.songName}
          </p>
          <p className={Classes.SongDescription}>
            {this.props.songAuthor}
          </p>
        </div>
        
        {/** Score */}
        <div className={['col-md-1', 'd-flex', 'align-items-center'].join(' ')}>
          <img
            src={require(`../../../assets/img/${trendArrow}`)}
            className={[Classes.ScoreIcon, 'img-responsive'].join(' ')}
            alt="Score Item"
            title="Score Item"
          />
        </div>
        {/** Votes */}
        <div className="col-md-2">
          <p className={Classes.SongTitle}>
            Like: {this.props.like}
          </p>
          <p className={Classes.SongTitle}>
            Unlike: {this.props.unlike}
          </p>
          <p className={Classes.SongDescription}>
            Duration: {this.props.duration} s
          </p>
        </div>
        { /** User image */}
        {
        userPicture[0] === '.' 
          ? (
            <div className={[Classes.TxtCenter, 'col-1'].join(' ')}>
              <img
                src={require('../../../assets/svg/anon-user.svg')}
                className={[Classes.SongUserAnon, 'img-responsive'].join(' ')}
                alt="User"
                title="User"
              />
              <p>{this.props.userName}</p>
            </div>
          ) : (
            <div className={[Classes.TxtCenter, 'col-1'].join(' ')}>
              <img 
                src={`${userPicture}`}
                className={[Classes.SongUser, 'img-responsive'].join(' ')}
                alt="User"
                title="User"
              />
               <p>{this.props.userName}</p>
            </div>
          )
        }
        <div className={`col-4 ${Classes.TxtCenter}`}>
          <div className="row col-12">
            <div className="col-4">
              <span data-tip="Elimina canzone" onClick={() => this.props.deteSongHandler(this.props.song)} className={`${Classes.Itemize} ${Classes.TxtCenter}`}>&nbsp;&nbsp;&nbsp;&nbsp;<i class={`fas fa-trash`}></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <br />
              <span data-tip="Riproduci subito" onClick={() => this.props.playNowHandler(this.props.song)} className={`${Classes.Itemize} ${Classes.TxtCenter}`}>&nbsp;&nbsp;&nbsp;&nbsp;<i class={`fas fa-fire`}></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <ReactTooltip />
              </div>
              <div className="col-4">
              <span  data-tip="Blocca utente (non attivo)"className={`${Classes.Itemize} ${Classes.TxtCenter}`}>&nbsp;&nbsp;&nbsp;&nbsp;<i class={`fas fa-user-alt-slash`}></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <br/>
              <span data-tip="Blocca canzone (non attivo)" className={`${Classes.Itemize} ${Classes.TxtCenter}`}>&nbsp;&nbsp;&nbsp;&nbsp;<i class={`fas fa-ban`}></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div className="col-4">
              <span data-tip="Fai salire di classifica" onClick={() => this.props.moveUpSongHandler(this.props.song)} className={`${Classes.Itemize} ${Classes.TxtCenter}`}>&nbsp;&nbsp;&nbsp;&nbsp;<i class={`fas fa-sort-amount-up-alt`}></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <br/>
              <span data-tip="Fai scendere di classifica" onClick={() => this.props.moveDownSongHandler(this.props.song)} className={`${Classes.Itemize} ${Classes.TxtCenter}`}>&nbsp;&nbsp;&nbsp;&nbsp;<i class={`fas fa-sort-amount-down-alt`}></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default NextSongControllableItem;
